<template>
  <div class="container">
    <div class="image-wrapper">
      <img :src="image" class="image-item" alt="" ref="imageWrapper"/>
      <div class="region-wrapper">
        <VueDraggableResizable
	        v-if="regionShow && !region.deleted"
	        :prevent-deactivation="preventDeactivation"
	        v-for="(region, idx) in regionsCopy"
	        :ref="`regionIdx${idx}`"
	        :key="region.id"
	        :active="false"
	        :parent="true"
	        class="region-item"
	        :w="wrapperSize.w * region.w"
	        :h="wrapperSize.h * region.h"
	        :x="wrapperSize.w * region.x"
	        :y="wrapperSize.h * region.y"
          :max-width="wrapperSize.w"
          :max-height="wrapperSize.h"
          :min-height="0"
          :min-width="0"
	        @dragging="() => onDrag(region.id)"
	        @actived="() => actived(region.id)"
	        @deactivated="onDeActive"
	        @resizestop="(x, y, w, h) => onResizingStop(x, y, w, h, region.id)"
	        @dragstop="(x, y) => onDragStop(x, y, region.id)"
	        :class="{fixed: region.fixed === true, new: region.new === true, active: activedItem === region.id}"
	        class-name-active="active"
        >
        </VueDraggableResizable>
      </div>
    </div>
    <div class="handler-wrapper">
      <span>序号{{!activedItem && activedItem !== 0 ? '无' : activedItem }}</span>
      <br>
      <el-button type="primary" @click="downLoad" class="btn" size="mini">下载此图</el-button>
      <br>
      <el-button :disabled="resetDisabled" class="btn" type="danger" :plain="true" @click="reset" size="mini">重置全部
      </el-button>
      <br>
      <el-button :disabled="activedItem === ''" class="btn" type="warning" :plain="true" @click="resetSelected" size="mini">重置选择
      </el-button>
      <br>
      <el-button :disabled="activedItem === ''" class="btn" type="danger" :plain="true" @click="deleteItem" size="mini">删除选择</el-button>
      <span class="hotkey">快捷键: del/backspace</span>
      <br>
      <el-button class="btn" type="success" :plain="true" @click="addRegion" size="mini">增加区域</el-button><span class="hotkey">快捷键: A
    </span>
      <br>
      <br>
      <el-select :value="activedItemCategory" @change="changeCategory" size="mini" :disabled="activedItem === ''"
                 placeholder="请选择"
                 class="select">
        <el-option
          v-for="item in category_list"
          :key="item.category"
          :label="item.category_desc"
          :value="item.category">
        </el-option>
      </el-select>
      <div class="label">没有想要的类型?<el-button type="text" size="mini" @click="addNewCategory">添加新类</el-button></div>
    </div>
     <el-form class="form" ref="form" label-width="40px" :inline="true">
        <el-form-item label="w">
          <el-input size="mini" v-model="currentRegion.w" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="h">
          <el-input size="mini" v-model="currentRegion.h" :disabled="true"></el-input>
        </el-form-item>
       <br>
        <el-form-item label="x">
          <el-input size="mini" v-model="currentRegion.x" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="y">
          <el-input size="mini" v-model="currentRegion.y" :disabled="true"></el-input>
        </el-form-item>
       <div class="btn-wrapper">
         <el-button type="warning" size="mini" @click="deleteImage">丢弃此图</el-button>
      <el-button type="danger" size="mini" @click="cancel">取消</el-button>
      <el-button type="primary" size="mini" @click="confirmFixRegion">确定</el-button>
       </div>
     </el-form>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import {apiDeleteImage, apiAddCategory, apiGetAllCategoryList} from '@/api';
export default {
  name: 'regionResize',
  components: {
    VueDraggableResizable
  },
  props: {
    id: {
      type: Number
    },
    image: {
      type: String
    },
    regions: {
      type: Array
    }
  },
  data () {
    return {
      preventDeactivation: false,
      activedItem: '',
      fixedItem: [],
      regionShow: false,
      wrapperSize: {},
      addDefaultRegion: {
        x: 0.3,
        y: 0.2,
        w: 0.3,
        h: 0.3,
        fixed: true,
        new: true,
        id: 0
      },
      regionsCopy: []
    };
  },
  mounted () {
    // console.log(this.$refs);
    this.regions.forEach((a, idx) => {
      this.$set(a, 'id', idx);
      if (!a.hasOwnProperty('category')) {
        this.$set(a, 'category', 1);
      }
    });
    this.regionsCopy = this.$_.cloneDeep(this.regions);
    this.computeSize();
    this.setWrapperSize();
    document.onkeydown = (e) => {
      const _key = window.event.keyCode;
      console.log(_key);
      if (_key === 46 || _key === 8) {
        this.deleteItem();
      }
      if (_key === 65) {
        this.addRegion();
      }
      // if (_key === )
    };
  },
  methods: {
    ...mapActions([]),
    downLoad () {
      window.open(this.image);
    },
    onDeActive () {
      // this.activedItem = '';
    },
    changeCategory (v) {
      console.log(v);
      let region = this.$_.find(this.regionsCopy, a => a.id === this.activedItem);
      this.$set(region, 'category', v);
    },
    addNewCategory () {
      this.$prompt('', '请输入要添加的类名', {
        distinguishCancelAndClose: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定添加',
        inputValidator: (v) => !!v,
        inputErrorMessage: '请输入类别名称'
      }).then(async ({value}) => {
        try {
          const res = await apiAddCategory([value]);
          this.$message.success('类别添加成功');
          this.getCategoryList();
        } catch (e) {
          this.$message.error('类别添加失败' + e.message);
        }
      }).catch((action) => {
        // console.log(action);
        if (action === 'cancel') {

        }
      });
    },
    async getCategoryList () {
      try {
        const res = await apiGetAllCategoryList();
        console.log(res);
        this.$store.commit('SET_ALL_CATEGORY_LIST', res);
        console.log(res);
      } catch (e) {
        console.log(e);
        this.$message.error('图框大类查询失败' + e.message);
      }
    },
    async deleteImage () {
      this.$confirm('请注意,此按钮将把此图片丢弃, 请确认此图片是否错误?', '确认信息', {
        type: 'error',
        cancelButtonText: '取消丢弃',
        confirmButtonText: '确认丢弃'
      }).then(async () => {
        // 确认丢弃
        try {
          await apiDeleteImage(this.id);
          this.$emit('delete', this.id);
          this.$message.success('此图片已丢弃');
          this.cancel();
        } catch (e) {
          this.$message.error('丢弃失败' + e.message);
        }
      }).catch(() => {
        // this.$message.error('确认丢弃');
      });
    },
    setWrapperSize () {
      this;
    },
    actived (id) {
      console.log(id);
    },
    computedFixed (id) {
      return !!this.$_.find(this.fixedItem, a => a.id);
    },
    confirmFixRegion () {
      this.$emit('confirmFixRegion', {
        id: this.id,
        fixedRegions: this.regionsCopy.filter(a => a.deleted !== true)
      });
    },
    cancel () {
      this.$emit('cancelDialog');
    },
    addRegion () {
      let obj = this.$_.cloneDeep(this.addDefaultRegion);
      obj.id = this.regionsCopy.length;
      this.regionsCopy.push(obj);
      const idx = this.regionsCopy.length - 1;
      // this.$nextTick(() => {
      //   const regionItem = this.$refs[`regionIdx${idx}`];
      //   console.log(regionItem);
      //   regionItem.className = 'add';
      // });
      //
      // regionItem.className = 'add';
      // this.fixedItem.indexOf(idx) === -1 && this.fixedItem.push(idx);
    },
    reset () {
      const copy = this.$_.cloneDeep(this.regionsCopy);
      this.regionsCopy = [];
      this.regionsCopy = this.$_.cloneDeep(this.regions);
      this.activedItem = '';
      // this.regionsCopy = this.$_.cloneDeep(copy);
      this.fixedItem = [];
    },
    resetSelected () {
      let idx = this.$_.findIndex(this.regionsCopy, a => a.id === this.activedItem);
      const regionCopy = this.$_.find(this.$_.cloneDeep(this.regions), a => this.activedItem === a.id);
      // // this.regionsCopy.splice(idx, 1, region);
      // // const idx2 = this.fixedItem.indexOf(idx);
      // let region = this.$_.find(this.regionsCopy, a => a.id);
      // console.log(regionCopy);
      // region = null;
      this.$set(this.regionsCopy, idx, regionCopy);
      console.log(regionCopy);
      // this.$set(region, regionCopy);
      // idx2 !== -1 && this.fixedItem.splice(idx2, 1);
    },
    deleteItem () {
      // console.log(this.activedItem);
      // const copy = this.$_.cloneDeep(this.regionsCopy);
      // console.log(this.$refs[`regionIdx${this.activedItem}`]);
      // this.$refs[`regionIdx${this.activedItem}`].destroy();
      // this.$_.pullAt(copy, this.activedItem);
      // this.regionsCopy = [];
      // this.regionsCopy = copy;
      let region = this.$_.find(this.regionsCopy, a => a.id === this.activedItem);
      this.$set(region, 'deleted', true);
      // this.regionsCopy.splice(idx, 1);
      // this.activedItem = '';
    },
    confirmDetectedRegion () {
      this.$emit('detectedRegion', this.defaultRegion);
    },
    onResizingStop (x, y, w, h, id) {
      function fixNum (num) {
        if (num > 1) {
          return 1;
        } else if (num < 0) {
          return 0;
        } else {
          return num;
        }
      }
      let wrapperSize = this.wrapperSize;
      let region = this.$_.find(this.regionsCopy, (a) => a.id === id);
      console.log(region);
      if (region) {
        region.x = fixNum(x / wrapperSize.w);
        region.y = fixNum(y / wrapperSize.h);
        region.w = fixNum(w / wrapperSize.w);
        region.h = fixNum(h / wrapperSize.h);
        // this.fixedItem.indexOf(id) === -1 && this.fixedItem.push(id);
        this.$set(region, 'fixed', true);
      }
      ;
    },
    onDrag (id) {
      // this.fixedItem.indexOf(id) === -1 && this.fixedItem.push(id);
      let region = this.$_.find(this.regionsCopy, a => a.id === id);
      this.$set(region, 'fixed', true);
    },
    onDragStop (x, y, id) {
      let wrapperSize = this.wrapperSize;
      let region = this.$_.find(this.regionsCopy, (a) => a.id === id);
      if (region) {
        region.x = x / wrapperSize.w;
        region.y = y / wrapperSize.h;
        // this.$set(region, 'actived', true);
        this.activedItem = id;
      }
    },
    computeSize () {
      this.$nextTick(() => {
        const imageWrapper = this.$refs['imageWrapper'];
        let width = imageWrapper.clientWidth;
        let img = new Image();
        img.src = this.image;
        img.onload = () => {
          this.wrapperSize = {
            w: width,
            h: (width / img.width) * img.height
          };
          this.regionShow = true;
        };
      });
    }
  },
  computed: {
    ...mapGetters(['category_list']),
    activedItemCategory () {
      if (this.activedItem === '') {
        return 1;
      } else {
        const regionCopy = this.$_.find(this.regionsCopy, a => this.activedItem === a.id);
        return regionCopy.hasOwnProperty('category') ? regionCopy['category'] : 1;
      }
    },
    currentRegion () {
      if (this.activedItem === '') {
        return {
          w: 0,
          h: 0,
          x: 0,
          y: 0
        };
      } else {
        const res = this.$_.find(this.regionsCopy, a => a.id === this.activedItem);
        return res || {
          w: 0,
          h: 0,
          x: 0,
          y: 0
        };
      }
    },
    fixedRegion () {
      return this.regionsCopy.filter(a => !a.deleted);
    },
    resetDisabled () {
      // return this.fixedItem.length === 0;
      return this.$_.isEqual(this.regions, this.regionsCopy);
    }
  },
  watch: {
  }
};
</script>
<style lang="scss" scoped>
.container {
  height: auto;
	.image-wrapper {
		position: relative;
		display: inline-block;
		height: auto;
		padding: 0;
		margin: 0;
		flex: 500px 0 0;
		.image-item {
      display: block;
			width: 500px;
			padding: 0;
			margin: 0;
		}

		.region-wrapper {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			.region-item {
				border: 2px solid $primary;
				&.fixed {
					border: 2px solid $success;
				}
        &.new {
          border: 2px solid #fcea00;
        }
				&.active {
					border: 2px solid $danger;
				}
			}
		}
	}
	.handler-wrapper {
		flex: 1;
		display: inline-block;
		vertical-align: top;
		height: 100%;
		margin-left: 20px;
		.btn {
			display: inline-block;
			margin: 5px;
		}
    .label {
      font-size: 12px;
    }
    .select {
      width: 100px;
    }
	}
  .form {
    .btn-wrapper{
      padding-top: 15px;
      float: right;
      display: inline-block;
    }
  }
  .hotkey {
    font-size: 12px;
  }
}

</style>
